import React from 'react';
import Product from '../../../models/Product';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper, darken } from  '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../../../theme/ThemeContext';

export interface Row {
  data: Product
  action?: 'create' | 'update' | 'error';
}

export const productStatusTypes = ['A', 'I', 'D', 'O']

export type ProductStatusType = typeof productStatusTypes[number]

export const productStatusTypeToDescription = (type: ProductStatusType): string => {
  switch (type) {
    case 'A': return "active"
    case 'I': return "inactive"
    case 'D': return "discontinued"
    case 'O': return "other"
  }
  return "not"
}

interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  fromIn?: boolean;
  onClickInfo?: (product: Product) => void;
  onChangePage?: (page: number) => void;
}

const Products: React.FC<Props> = (props) => {  
  const { t } = useTranslation('product')
  const { theme } = useThemeContext()

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }
  return (
      <Paper style={{borderRadius: "10px", margin: props.fromIn ? "-10px" : "10px"}}>
      { !props.fromIn && <ISTableTitle title={t('title')}/> }
      <Table style={{whiteSpace:"nowrap", overflow:"hidden"}} size="medium" >
        <TableHead>
          <TableRow selected={true}>
            <ISTableHeaderCell>{t('code')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('description')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('information')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('section')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('brand')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('group')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('subgroup')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('measurement')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('package')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('status')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { !props.loading && props.rows.map((row, index) =>
            <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{cursor: 'pointer', backgroundColor: row.data.status === 'I' ? darken(theme.palette.action.hover, 0.1) : ''}}
            onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data) }}>
              <TableCell>{row.data.code}</TableCell>
              <TableCell>{row.data.description}</TableCell>
              <TableCell>{row.data.information}</TableCell>
              <TableCell>{row.data.sectionName}</TableCell>
              <TableCell>{row.data.brandName}</TableCell>
              <TableCell>{row.data.groupName}</TableCell>
              <TableCell>{row.data.subgroupName}</TableCell>
              <TableCell>{row.data.measurementName}</TableCell>
              <TableCell>{row.data.package}</TableCell>
              <TableCell>{t(`${productStatusTypeToDescription(row.data.status)}`)}</TableCell>
            </ISTableRow>
          )}
        </TableBody>
      </Table>
      { props.loading &&
        <div style={{display:'flex', justifyContent:'center'}}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Paper>
  );
}

export default Products

